import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Base64 from 'js-base64';
import commmonWebConfig from "@/utils/util";

var ajaxSubmit = {};


ajaxSubmit.allUrl={
  /**提交报名信息***/
  "applyForTcjAsyn":"/adConfig/tcj/applyForTcjAsyn",
  /*获取品牌*/
  "tcBrand":"/baseData/car/tcBrand",
	/*获取车型*/
  "baseDataTcStyle":"/baseData/car/tcStyle",

}

ajaxSubmit.signUrl = [
  /*************M站报名接口等***************/ 
  {
    url:"/adConfig/tcj/applyForTcjAsyn",
    type:"adConfig"
  },
  {
    url:"/adConfig/tcj/supplementForM",
    type:"adConfig"
  }
  /*************M站报名接口等***************/ 
];
//获取签名的url
var signAjax = {
  // "comparison":"//t.login.tuanche.com/key/curinfo",
  "adConfig":SIGNTUREPATH.signAPI + "/key/curinfo",
  // "adConfig":commmonWebConfig.tuancheapi + "/adConfig/tcj/signParam"
};

ajaxSubmit.ajax = function(option){
  //默认data传值
  option.data = option.data ? option.data : {};
  //url, data, success, cache, alone, async, type, dataType, error
  var url = option.url;
  var data = option.data;
  var type = option.type || 'post';//请求类型
  var dataType = option.dataType || 'json';//接收数据类型
  var async = option.async || true;//异步请求
  var cache = option.cache || false;//浏览器历史缓存
  var xhrFields = option.xhrFields || false;//发送Ajax时，Request header中会带上 Cookie 信息
  // var crossDomain = option.crossDomain || false; // 发送Ajax时，Request header 中会包含跨域的额外信息，但不会含cookie
  var contentType = option.contentType || 'application/x-www-form-urlencoded; charset=UTF-8';
  if(typeof(option.headers) != "undefined"){
    option.headers.platform = 5;
    option.headers.source = -1;
  }
  var headers = option.headers || { "platform":5 , "source":-1 }
  // var headers = option.headers || { }
  var success = function (data) {
          Indicator.close();
          if(data.responseHeader.status != 200 && data.responseHeader.status!=5001){//回传非200的code
              Toast({
                message: data.responseHeader.message,
                position: 'middle',
                duration: 2000
              });
          }
          option.success ? option.success(data) : "";
      };
  var error = function (jqXHR, textStatus, errorThrown) {
          Indicator.close();
          Toast({
            message: '请求失败',
            position: 'middle',
            duration: 2000
          });
          option.error ? option.error() : "";
  };


  /***************接口sign加密***************/
 
  var curSignUrl = "";
  function getSign(params, time, version, key) {
      if (typeof params == "string") {
          return paramsStrSort(params);
      } else if (typeof params == "object") {
        var arr = [];
        for (var i in params) {
            if(params[i] != undefined){
              arr.push((i + "=" + params[i]));
            }
          }
        }
      return paramsStrSort(arr.join(("||")),time,version,key);
  }

  function paramsStrSort(paramsStr,time,version,key) {
      var url = paramsStr;
      //console.log(url);
      var urlStr = url.split("||").sort().join("&");
      var newUrl = urlStr +'&kv='+ version + '&tctimestamp='+ time + key;
      // console.log(newUrl);
      return md5(newUrl);
  }

  //传入url  判断是否需要检验
  function isSign(url){
    var isSign = false;
    for(var  i in ajaxSubmit.signUrl){
      if(url.indexOf(ajaxSubmit.signUrl[i].url) != -1){
        isSign = true;
        curSignUrl = signAjax[ajaxSubmit.signUrl[i].type];
      }
    };
    return isSign
  }
   /***************接口sign加密***************/
  // 获取本地缓存
  function getsignCacheData(){
    var values = window.localStorage.getItem('signData');
    var dataObj = JSON.parse(values);
    if(dataObj==''||dataObj==null||JSON.stringify(dataObj)=='{}') return true;
    if(new Date().getTime() - dataObj.time>(1000*60*30)) {
    // console.log('信息已过期');
      localStorage.removeItem('signData');
      return true;
    }else{
      // 获取当前本地时间戳
      var currentTime = new Date().getTime();
      var sign = getSign(data,currentTime, dataObj.data.kv, dataObj.data.key);
      data.tcsign = sign;
      data.kv = dataObj.data.kv;
      data.tctimestamp = currentTime;
      // console.log(data);
      return false;
    }
  }
  function setsignCacheData(data){
    var curTime = new Date().getTime();
    window.localStorage.setItem('signData', JSON.stringify({
      data: data,
      time: curTime
    }));
  }

  if(isSign(url)){
    if(getsignCacheData()){
      $.ajax({
        url:curSignUrl,
        type:"get",
        dataType:"json",
        // headers: headers,
        success:function(signData){
          // 对手机号和名字加密
          for(var i in data){
            if(i == "name" || i == "phone"){
              console.log(data[i]);
              data[i] = Base64.Base64.btoa(encodeURIComponent(data[i]));
              console.log(data[i])
            }
          };
          // 获取当前本地时间戳
          var currentTime = new Date().getTime();
          var sign = getSign(data, currentTime, signData.response.result.kv , signData.response.result.key);
          data.tcsign = sign;
          data.kv = signData.response.result.kv;
          data.tctimestamp = currentTime;
          setsignCacheData({key:signData.response.result.key,kv:signData.response.result.kv,tctimestamp:currentTime});
          if(contentType=='application/json'){
            data=JSON.stringify(data);
          }
          $.ajax({
              url: url,
              data: data,
              type: type,
              contentType: contentType,
              dataType: dataType,
              async: async,
              timeout:50000,
              success: success,
              error: error,
              headers: headers,
              xhrFields:xhrFields,
              // crossDomain:crossDomain
          });
        },
        error:function(){
          console.log("post获取签名失败")
        }
      }) 
    }else{
      // 对手机号和名字加密
      for(var i in data){
        if(i == "name" || i == "phone"){
          console.log(data[i]);
          data[i] = Base64.Base64.btoa(encodeURIComponent(data[i]));
          console.log(data[i])
        }
      };
      if(contentType=='application/json'){
        data=JSON.stringify(data);
      }
      $.ajax({
          url: url,
          data: data,
          type: type,
          contentType: contentType,
          dataType: dataType,
          async: async,
          timeout:50000,
          success: success,
          error: error,
          headers: headers,
          xhrFields:xhrFields,
          // crossDomain:crossDomain
      });
    }
  }else{
    $.ajax({
        url: url,
        data: data,
        type: type,
        contentType: contentType,
        dataType: dataType,
        async: async,
        timeout:50000,
        success: success,
        error: error,
        headers:headers,
        xhrFields:xhrFields,
        // crossDomain:crossDomain
    });
  }
    
}

export default ajaxSubmit;



// WEBPACK FOOTER //
// ./src/utils/ajaxSubmit.js